@if (select.allowMultiple) {
<div>
  <kendo-multiselect #multiselect
                     [id]="select.id"
                     [name]="select.id"
                     [data]="select.data"
                     [valueField]="select.valueMember"
                     [textField]="select.displayMember"
                     [(ngModel)]="select.value"
                     [placeholder]="select.placeHolder"
                     [filterable]="true"
                     [allowCustom]="true"
                     (filterChange)="filter($event)"
                     [clearButton]="true"
                     size="medium"
                     rounded="large"
                     fillMode="solid"
                     [autoClose]="autoClose"
                     (open)="open()"
                     (close)="close()"
                     (valueChange)="change($event)"
                     [disabled]="select.isReadOnly"
                     class="multi-select">
    <div class="k-data-table k-table-md">
      <ng-template kendoMultiSelectNoDataTemplate>
        <span class="k-icon k-i-exclamation-circle"></span><br /><br />
        <span id="noDataLabel">
          {{ select.noResultMessage }}
        </span>
      </ng-template>
      <ng-template kendoMultiSelectHeaderTemplate>
        <div class="k-table-header k-table-md" style="padding-right: 17px">
          <div class="k-table-header-wrap">
            <table class="k-table" role="presentation">
              <colgroup>
                @for (column of select.columns; track column.field) {
                <col width="{{column.size}}px" /> }
              </colgroup>
              <thead class="k-table-thead">
                <tr class="k-table-row">
                  @for (column of select.columns; track column.field) {
                  <th class="k-table-th">
                    {{ column.title }}
                  </th>
                  }
                </tr>
              </thead>
            </table>
          </div>
        </div>
      </ng-template>
      <ng-template kendoMultiSelectItemTemplate let-dataItem>
        <div class="k-table-body k-table-scoller" style="max-height:200px">
          <ul role="listbox" class="k-table k-table-list">
            <li role="option" class="k-table-row" tabindex="-1">
              @for (column of select.columns; track column.field) {
              <span class="k-table-td">
                {{ dataItem[column.field] }}
              </span>
              }
            </li>
          </ul>
        </div>
      </ng-template>
    </div>
  </kendo-multiselect>
</div>

} @else {
<div>
  <kendo-multicolumncombobox [id]="select.id"
                             [data]="select.data"
                             [valueField]="select.valueMember"
                             [textField]="select.displayMember"
                             [(ngModel)]="select.singleValue"
                             [placeholder]="select.placeHolder"
                             [filterable]="true"
                             [allowCustom]="true"
                             (filterChange)="filter($event)"
                             [clearButton]="true"
                             size="medium"
                             rounded="large"
                             fillMode="solid"
                             (open)="open()"
                             (close)="close()"
                             (valueChange)="change($event)"
                             [disabled]="select.isReadOnly"
                             [style]="select.includeAddEditLink == true ? 'width:77%' : 'width:100%'">
    @for (column of select.columns; track column.field) {
    <kendo-combobox-column [field]="column.field"
                           [title]="column.title"
                           [width]="column.size">
    </kendo-combobox-column>
    }
    <ng-template kendoMultiColumnComboBoxNoDataTemplate>
      <span class="k-icon k-i-exclamation-circle"></span><br /><br />
      <span id="noDataLabel">
        {{ select.noResultMessage }}
      </span>
    </ng-template>
  </kendo-multicolumncombobox>
  @if (select.includeAddEditLink == true) {
  <kendo-splitbutton buttonClass="greenDarkBg" text="Action" title="Action" [data]="actionLinks" style="margin-left:8px" (itemClick)="addEditSubItemSelected($event)"></kendo-splitbutton>
  }
</div>
}


